/**
 *  Management of Application State
 */
import { createStore } from 'vuex'
import MyColors from "@/plugins/MyColors"
import { i18n } from './i18n.js'

export default createStore({

  state: {
    // colors
    stdColorLight: MyColors.stdColorLight,
    stdColorDark: MyColors.stdColorDark,
    stdColorSelectedRow: MyColors.stdColorSelectedRow,
    colorCartOn: MyColors.colorCartOn,
    colorCartOff: MyColors.colorCartOff,
    colorSystemBarOn: MyColors.colorSystemBarOn,
    colorSystemBarOff: MyColors.colorSystemBarOff,

    // system bar
    systemBarColor: MyColors.colorSystemBarOff,

    // navigation
    navigationDrawer: {
      permanent: true,
      drawer: false
    },

    // selected language
    selectedLanguage: null,

    // v-model selected SAP Client
    selectedSAPClient: "AS400",

    // router views in App
    routerViewToolbar: 'appToolbar',
    routerViewContent: 'appContent',

    // master data states
    masterDataState: {
      showUser: false,
      showPL: true,
      showCustomerWarehouse: false,
      showDataTarget: false,
      showOrder: false
    },

    // state of search control 0=Artikelnummer,1=strukturiert,2=frei
    searchControl: 0,

    // v-model states Pulverlagerliste
    plFreeSearch: "",    
    artNr: "",
    produktReihe: "",
    glanzgrad: "",
    struktur: "",
    innenAussen: "",
    farbton: {
      farbton: "",
      farbtonBez: ""
    },
    kdnnrCustomerWarehouse: 0,

    // parameter for selection
    plParameter: {
      sprcd: 1,
      produktReihe: "%",
      glanzgrad: "%",
      struktur: "%",
      innenAussen: "%",
      farbton: "%",
      kdnnr: 0,
      sapClientId: "AS400"
    },
    plComboData: {},

    plConfig: {
      plTitle: i18n.global.t('message.plliste'),
      plIcon: 'md:analytics'
    },

    hasCustomerWarehouse: false,

    plList: [],
    plArtikelData: [],
    userList: [],
    dataTargetList: [],
    odataTargetList: [],
    orderList: [],
    sdbBase64Document: '',

    // states of logon
    user: null,

    actualUser: {
      username: "",
      password: ""
    },

    isLoggedOn: false,

    //Shopping Cart
    cartColor: MyColors.colorCartOff,
    cartCounter: 0,
    showOrderForm: false,
    plShoppingList: [],

    //document states
    showTmb: false,
    showFlyer: false,
    showVideoPlayer: false,
    showSDB: false,

    //confirm dialog
    confirmDialog: {
      showConfirmDialog: false,
      message: "",
      action: null,
      params: []
    },

    //error dialog
    errorDialog: {
      showErrorDialog: false,
      sqlCode: 0,
      sqlState: "",
      sqlMessage: "",
      myErrorCode: 0
    },

    //report
    reportUsername: 'kabe',
    reportPassword: 'reporting@2023',
    report: {
      showReport: false,
      name: "",
      title: "",
      reportData: {
        name: "",
        outputType: "HTML",
        inputType: "LIST",
        parameters: [],
        dataSets: []
      }
    },

    //Help
    showHelpList: false,

    //REST API
    login: 'users/login',
    getUser: 'users',
    getUserNoAuth: 'users/noauth',
    getCustomer: 'users/customers',
    getComboData: 'pl/combobox/data',
    getPLByArtikel: 'pl/artikel/artnr',
    getPLByParameter: 'pl/artikel/parameters',
    getReport: 'reporting/birt/reports',
    createLogEntry: 'log',
    sendEMail: 'pl/email/send',
    getPLArtikelData: 'pl/artikelext/artnr',
    issueNewPassword: 'users/noauth/newpassword',
    setNewPassword: 'users/pw/savepassword',
    sdbProductImage: 'sdb/sdb/productimage/',
    sdbPdf: 'sdb/sdb/pdf',
    dataTargetBase: 'targets',
    getDataTargets: 'targets/all',
    getDataTarget: 'targets/single',
    getODataTargets: 'targets/odata',
    getOrderEntrys: 'plorderlog/entrys',
    getOrderEntry: 'plorderlog/entry',
    deleteOrder: 'plorderlog',
    createOrder: 'plorderlog',
    createMessageLogEntry: 'logcentral',
    getLogInfo: 'logcentral/loginfo'
  },

  mutations: {
    SET_SYSTEMBAR_COLOR(state, systemBarColor) {
      state.systemBarColor = systemBarColor
    },

    SET_NAVIGATION_DAWER(state, visible) {
      state.navigationDrawer.drawer = visible
    },

    SET_NAVIGATION_DAWER_PERMANENT(state, permanent) {
      state.navigationDrawer.permanent = permanent
    },

    SET_PLSHOPPINGLIST(state, plShoppingList) {
      state.plShoppingList = plShoppingList
    },

    SET_PLFREESEARCH(state, plFreeSearch) {
      state.plFreeSearch = plFreeSearch
    },

    SET_SEARCHCONTROL(state, searchControl) {
      state.searchControl = searchControl
    },

    SET_SELECTEDLANGUAGE(state, selectedLanguage) {
      state.selectedLanguage = selectedLanguage
    },

    SET_SELECTEDSAPCLIENT(state, selectedSAPClient) {
      state.selectedSAPClient = selectedSAPClient
    },

    SET_DATATARGET_LIST(state, dataTargetList) {
      state.dataTargetList = dataTargetList
    },

    SET_ODATATARGET_LIST(state, odataTargetList) {
      state.odataTargetList = odataTargetList
    },

    SET_ORDER_LIST(state, orderList) {
      state.orderList = orderList
    },

    SET_ROUTERVIEW_TOOLBAR(state, routerViewToolbar) {
      state.routerViewToolbar = routerViewToolbar
    },

    SET_ROUTERVIEW_CONTENT(state, routerViewContent) {
      state.routerViewContent = routerViewContent
    },

    SET_CUSTOMERWAREHOUSE(state, hasCustomerWarehouse) {
      state.hasCustomerWarehouse = hasCustomerWarehouse
    },

    SET_PL_LIST(state, plList) {
      state.plList = plList
    },

    SET_USER_LIST(state, userList) {
      state.userList = userList
    },

    SET_PL_ARTIKELDATA(state, plArtikelData) {
      state.plArtikelData = plArtikelData
    },

    SET_PL_SDBBASE64DOCUMENT(state, sdbBase64Document) {
      state.sdbBase64Document = sdbBase64Document
    },

    SET_ARTIKEL(state, artNr) {
      state.artNr = artNr
    },

    SET_KDNNR_CUSTOMERWAREHOUSE(state, kdnnrCustomerWarehouse) {
      state.kdnnrCustomerWarehouse = kdnnrCustomerWarehouse
    },

    SET_PRODUKTREIHE(state, produktReihe) {
      state.produktReihe = produktReihe
    },

    SET_GLANZGRAD(state, glanzgrad) {
      state.glanzgrad = glanzgrad
    },

    SET_STRUKTUR(state, struktur) {
      state.struktur = struktur
    },

    SET_INNENAUSSEN(state, innenAussen) {
      state.innenAussen = innenAussen
    },

    SET_FARBTON(state, farbton) {
      state.farbton=farbton
    },

    SET_PL_CONFIG(state, plConfig) {
      state.plConfig = Object.assign({}, plConfig);
    },

    SET_PL_PARAMETER(state, plParameter) {
      state.plParameter = plParameter
    },

    SET_PL_COMBODATA(state, plComboData) {
      state.plComboData = plComboData
    },

    SET_USER(state, user) {
      state.user = user
    },

    SET_ACTUALUSER(state, actualUser) {
      //we do not want the reference but a clone of the object
      state.actualUser=Object.assign({}, actualUser);
    },

    SET_LOGGED_ON(state, isLoggedOn) {
      state.isLoggedOn = isLoggedOn
    },

    SET_CARTCOLOR(state, cartColor) {
      state.cartColor = cartColor
    },

    SET_CARTCOUNTER(state, cartCounter) {
      state.cartCounter = cartCounter
    },

    SET_ORDERFORM_STATE(state, showOrderForm) {
      state.showOrderForm = showOrderForm
    },

    SET_TMB_STATE(state, showTmb) {
      state.showTmb = showTmb
    },

    SET_FLYER_STATE(state, showFlyer) {
      state.showFlyer = showFlyer
    },

    SET_VIDEOPLAYER_STATE(state, showVideoPlayer) {
      state.showVideoPlayer = showVideoPlayer
    },

    SET_SDB_STATE(state, showSDB) {
      state.showSDB = showSDB
    },

    SET_CONFIRMDIALOG_STATE(state, confirmDialog) {
      state.confirmDialog.message = confirmDialog.message
      state.confirmDialog.action = confirmDialog.action
      state.confirmDialog.params = confirmDialog.params
      state.confirmDialog.showConfirmDialog = confirmDialog.showConfirmDialog
    },

    SET_ERRORDIALOG_STATE(state, errorDialog) {
      state.errorDialog.sqlCode = errorDialog.sqlCode
      state.errorDialog.sqlState = errorDialog.sqlState
      state.errorDialog.sqlMessage = errorDialog.sqlMessage
      state.errorDialog.myErrorCode = errorDialog.myErrorCode
      state.errorDialog.showErrorDialog = errorDialog.showErrorDialog
    },

    SET_REPORT_STATE(state, report) {
      state.report=Object.assign({}, report);
    },

    SET_MASTERDATA_STATE(state, masterDataState) {
      state.masterDataState = masterDataState
    },

    SET_HELPLIST_STATE(state, showHelpList) {
      state.showHelpList = showHelpList
    }

  },

  actions: {
    setSystemBarColor(context, systemBarColor) {
      context.commit("SET_SYSTEMBAR_COLOR", systemBarColor)
    },

    setNavigationDrawer(context, visible) {
      context.commit("SET_NAVIGATION_DAWER", visible)
    },

    setNavigationDrawerPermanent(context, permanent) {
      context.commit("SET_NAVIGATION_DAWER_PERMANENT", permanent)
    },

    setPlShoppingList(context, plShoppingList) {
      context.commit("SET_PLSHOPPINGLIST", plShoppingList)

    },

    setPlFreeSearch(context, plFreeSearch) {
      context.commit("SET_PLFREESEARCH", plFreeSearch)
    },

    setSearchControl(context, searchControl) {
      context.commit("SET_SEARCHCONTROL", searchControl)
    },

    setSelectedLanguage(context, selectedLanguage) {
      context.commit("SET_SELECTEDLANGUAGE", selectedLanguage)
    },

    setSelectedSAPClient(context, selectedSAPClient) {
      context.commit("SET_SELECTEDSAPCLIENT", selectedSAPClient)
    },

    setDataTargetList(context, dataTargetList) {
      context.commit("SET_DATATARGET_LIST", dataTargetList)
    },

    setODataTargetList(context, odataTargetList) {
      context.commit("SET_ODATATARGET_LIST", odataTargetList)
    },

    setOrderList(context, orderList) {
      context.commit("SET_ORDER_LIST", orderList)
    },

    setRouterViewToolbar(context, routerViewToolbar) {
      context.commit("SET_ROUTERVIEW_TOOLBAR", routerViewToolbar)
    },

    setRouterViewContent(context, routerViewContent) {
      context.commit("SET_ROUTERVIEW_CONTENT", routerViewContent)
    },

    setArtikel(context, artNr) {
      context.commit("SET_ARTIKEL", artNr)
    },

    setKdnnrCustomerWarehouse(context, kdnnrCustomerWarehouse) {
      context.commit("SET_KDNNR_CUSTOMERWAREHOUSE", kdnnrCustomerWarehouse)
    },

    setProduktReihe(context, produktReihe) {
      context.commit("SET_PRODUKTREIHE", produktReihe)
    },

    setGlanzgrad(context, glanzgrad) {
      context.commit("SET_GLANZGRAD", glanzgrad)
    },

    setStruktur(context, struktur) {
      context.commit("SET_STRUKTUR", struktur)
    },

    setInnenAussen(context, innenAussen) {
      context.commit("SET_INNENAUSSEN", innenAussen)
    },

    setFarbton(context, farbton) {
      context.commit("SET_FARBTON", farbton)
    },

    setCustomerWarehouse(context, hasCustomerWarehouse) {
      context.commit("SET_CUSTOMERWAREHOUSE", hasCustomerWarehouse)
    },

    setPLConfig(context, plConfig) {
      context.commit("SET_PL_CONFIG", plConfig)
    },

    setPLParameter(context, plParameter) {
      context.commit("SET_PL_PARAMETER", plParameter)
    },

    setPLComboData(context, plComboData) {
      context.commit("SET_PL_COMBODATA", plComboData)
    },

    setPLList(context, plList) {
      context.commit("SET_PL_LIST", plList)
    },

    setUserList(context, userList) {
      context.commit("SET_USER_LIST", userList)
    },

    setPLArtikelData(context, plArtikelData) {
      context.commit("SET_PL_ARTIKELDATA", plArtikelData)
    },

    setSDBBase64Document(context, sdbBase64Document) {
      context.commit("SET_PL_SDBBASE64DOCUMENT", sdbBase64Document)
    },

    setUser(context, user) {
      context.commit("SET_USER", user)
    },

    setActualUser(context, actualUser) {
      context.commit("SET_ACTUALUSER", actualUser)
    },

    setLoggedOn(context, isLoggedOn) {
      context.commit("SET_LOGGED_ON", isLoggedOn)
    },

    setCartColor(context, cartColor) {
      context.commit("SET_CARTCOLOR", cartColor)
    },

    setCartCounter(context, cartCounter) {
      context.commit("SET_CARTCOUNTER", cartCounter)
    },

    setShowOrderForm(context, showOrderForm) {
      context.commit("SET_ORDERFORM_STATE", showOrderForm)
    },

    setShowTmb(context, showTmb) {
      context.commit("SET_TMB_STATE", showTmb)
    },

    setShowFlyer(context, showFlyer) {
      context.commit("SET_FLYER_STATE", showFlyer)
    },

    setShowVideoPlayer(context, showVideoPlayer) {
      context.commit("SET_VIDEOPLAYER_STATE", showVideoPlayer)
    },

    setShowSDB(context, showSDB) {
      context.commit("SET_SDB_STATE", showSDB)
    },

    setConfirmDialog(context, confirmDialog) {
      context.commit("SET_CONFIRMDIALOG_STATE", confirmDialog)
    },

    setErrorDialog(context, errorDialog) {
      context.commit("SET_ERRORDIALOG_STATE", errorDialog)
    },

    setReport(context, report) {
      context.commit("SET_REPORT_STATE", report)
    },

    setMasterDataState(context, masterDataState) {
      context.commit("SET_MASTERDATA_STATE", masterDataState)
    },

    setShowHelpList(context, showHelpList) {
      context.commit("SET_HELPLIST_STATE", showHelpList)
    }

  },

  getters: {
    systemBarColor: state => state.systemBarColor,
    
    // get shopping list
    plShoppingList: state => state.plShoppingList,

    // get search state PL
    plFreeSearch: state => state.plFreeSearch,

    // get search control
    searchControl: state => state.searchControl,

    // get selected language
    selectedLanguage: state => state.selectedLanguage,

    // get selected SAP Client
    selectedSAPClient: state => state.selectedSAPClient,
    isSAP: state => state.selectedSAPClient!=="AS400",

    // get state of routerViewToolbar
    routerViewToolbar: state => state.routerViewToolbar,

    // get state of routerViewContent
    routerViewContent: state => state.routerViewContent,

    //get v-model state for Pulverlagerliste
    artikel: state => state.artNr,
    produktReihe: state => state.produktReihe,
    glanzgrad: state => state.glanzgrad,
    struktur: state => state.struktur,
    innenAussen: state => state.innenAussen,
    farbton: state => state.farbton,
    kdnnrCustomerWarehouse: state => state.kdnnrCustomerWarehouse,

    // get Pulverlagerliste depending on selection
    hasCustomerWarehouse: state => state.hasCustomerWarehouse,
    plConfig: state => state.plConfig,
    plParameter: state => state.plParameter,
    plComboData: state => state.plComboData,
    plList: state => state.plList,
    plArtikelData: state => state.plArtikelData,
    sdbBase64Document: state => state.sdbBase64Document,
    userList: state => state.userList,
    dataTargetList: state => state.dataTargetList,
    odataTargetList: state => state.odataTargetList,
    orderList: state => state.orderList,

    // get current user
    user: state => state.user,
    username: state => state.actualUser.username,
    password: state => state.actualUser.password,
    actualUser: state => state.actualUser,

    // get current logon state
    isLoggedOn: state => state.isLoggedOn,

    // get color and counter for Cart
    cartColor: state => state.cartColor,
    cartCounter: state => state.cartCounter,
    showOrderForm: state => state.showOrderForm,

    // document states
    showTmb: state => state.showTmb,
    showFlyer: state => state.showFlyer,
    showVideoPlayer: state => state.showVideoPlayer,
    showSDB: state => state.showSDB,

    // confirm dialog
    showConfirmDialog: state => state.confirmDialog.showConfirmDialog,
    confirmDialog: state => state.confirmDialog,

    // error dialog
    showErrorDialog: state => state.errorDialog.showErrorDialog,
    errorDialog: state => state.errorDialog,

    // report
    reportUsername: state => state.reportUsername,
    reportPassword: state => state.reportPassword,
    showReport: state => state.report.showReport,
    report: state => state.report,

    // master data
    masterDataState: state => state.masterDataState,
    showUser: state => state.masterDataState.showUser,
    showPL: state => state.masterDataState.showPL,
    showCustomerWarehouse: state => state.masterDataState.showCustomerWarehouse,
    showDataTarget: state => state.masterDataState.showDataTarget,
    showOrder: state => state.masterDataState.showOrder,

    // help
    showHelpList: state => state.showHelpList,

    // getters for PL REST API
    login: state => state.login,
    getUser: state => state.getUser,
    getUserNoAuth: state => state.getUserNoAuth,
    getCustomer: state => state.getCustomer,
    getComboData: state => state.getComboData,
    getPLByArtikel: state => state.getPLByArtikel,
    getPLByParameter: state => state.getPLByParameter,
    getReport: state => state.getReport,
    createLogEntry: state => state.createLogEntry,
    sendEMail: state => state.sendEMail,
    getPLArtikelData: state => state.getPLArtikelData,
    issueNewPassword: state => state.issueNewPassword,
    setNewPassword: state => state.setNewPassword,
    sdbProductImage: state => state.sdbProductImage,
    sdbPdf: state => state.sdbPdf,
    dataTargetBase: state => state.dataTargetBase,
    getDataTargets: state => state.getDataTargets,
    getDataTarget: state => state.getDataTarget,
    getODataTargets: state => state.getODataTargets,
    getOrderEntrys: state => state.getOrderEntrys,
    getOrderEntry: state => state.getOrderEntry,
    deleteOrder: state => state.deleteOrder,
    createOrder: state => state.createOrder,
    createMessageLogEntry: state => state.createMessageLogEntry,
    getLogInfo: state => state.getLogInfo,

    //getters for colors:
    stdColorLight: state => state.stdColorLight,
    stdColorDark: state => state.stdColorDark,
    stdColorSelectedRow: state => state.stdColorSelectedRow,
    colorCartOn: state => state.colorCartOn,
    colorCartOff: state => state.colorCartOff,
    colorSystemBarOn: state => state.colorSystemBarOn,
    colorSystemBarOff: state => state.colorSystemBarOff
  }
})
